export const SET_USUARIO = 'SET_USUARIO';
export const SET_USUARIOS = 'SET_USUARIOS';
export const SET_PERFIL = 'SET_PERFIL';
export const OPEN_USUARIO = 'OPEN_USUARIO';
export const CLOSE_USUARIO = 'CLOSE_USUARIO';
export const UPDATE_USUARIOS = 'UDPATE_USUARIOS';
export const ADD_USUARIOS = 'ADD_USUARIOS';
export const REMOVE_USUARIOS = 'REMOVE_USUARIOS';
export const SET_USUARIO_SEARCH = 'SET_USUARIO_SEARCH';